import React,{useState} from "react";
import Navbar from "../navbar/navbar";
import { api } from "../../services/api";
import { Link,Navigate,useParams } from 'react-router-dom'
import { useEffect } from "react";
import './grupo.css'
import { vhostV1, vhostV2 } from "../funcoes";
import SweetAlert from "react-bootstrap-sweetalert";
import FooterBar from "../footer/footerBar";
import semImagem from "../../images/semImagem.jpg";
import BuscaVazaia from "../components/buscavazia/buscaVazia";





function NovoGrupo(props){

  document.addEventListener("keydown", function(e) {

    if(e.keyCode === 13) {
      
      e.preventDefault();
      
    }
  
  });

  const {tag} = useParams();
  const {id} = useParams();

   const [descricao,setDescricao]  = useState('');
   const [cor,setCor]              = useState('');
   const [carga,setCarga]          = useState("1");
   const [sucesso,setSucesso]      = useState('N');
   const [ctWeb, setCtWeb] = useState('0');
   const [file, setFile] = useState(null);
   const [mensagem, setMensagem]   = useState('');
   const [erroValidacao, setErrovalidacao] = useState(false);
   const [msgErro, setmsgErro] = useState('');
   const [isModalOpenImage, setIsModalOpenImage] = useState(false);
   const [imagemProduto, setImagemProduto] = useState(semImagem);
   const [autoAtendimento, setAutoAtendimento] = useState('')
   const [gruposCtWeb, setGruposCtWeb] = useState([]);
   const [buscaCtWeb, setBuscaCtWeb] = useState('');
   const loja = localStorage.getItem('loja');
    
   let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  let config2 = {
    headers: {
      'Authorization': localStorage.getItem("token2")
    }
  }


   //buscar grupo se for edicao
  useEffect(function(){
    
    api.get(vhostV1('webcash/grupos/'+Number(id)),config)
      .then(function (response) {
        console.log(response);

         if (response.data.imagem !== null) {
            setImagemProduto(response.data.imagem);
          }
        
        setDescricao(response.data.dados.DESCRICAO); 
        setCarga(response.data.dados.CARGA); 
        setCor(response.data.dados.COR);    
        setCtWeb(response.data.dados.CAT_WEB);
        
                 
      })
      .catch(function (error) {
       
        console.log(error);

                
      });

      
  },[])


     useEffect(function(){
      
        api.post(vhostV1("webcash/ftp/run"), {
      query: `SELECT 
      id as COD_GRUPO,
      nome as DESCRICAO,
      status as CARGA 
      FROM categorias WHERE rel_estabelecimentos_id = ${loja}
      AND nome LIKE '%${buscaCtWeb}%'`,
      params: []
    }, config)
    .then(res => {
      console.log(res.data);
      
      setGruposCtWeb(res.data.dados); 
    })
    .catch(err => console.error(err));
            
          
      },[buscaCtWeb])

      useEffect(function () {

  const body = buscaCtWeb
    ? { grupo_id: Number(buscaCtWeb) }
    : {};

  api.post(
    vhostV1("webcash/mpm/listarGrupos"),
    body,
    config
  )
  .then(res => {
    console.log(res);
    setGruposCtWeb(res.data.dados.data);
  })
  .catch(err => console.error(err));

}, [buscaCtWeb]);

   function salvaGrupo(e){
    e.preventDefault();
    // const sJson = {
    //   COD_GRUPO:Number(id),          
    //   DESCRICAO:descricao,
  
    //   CARGA:carga,
    // }

    // console.log(sJson);
    
    

    if(descricao.length === 0){  
      {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
          setErrovalidacao(true)}
      return    
  }else if(descricao === ' '){
    {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
      setErrovalidacao(true)}
  }
    
    else{

        api.post(vhostV1('webcash/grupos/inclui'),{
            COD_GRUPO:Number(id),          
            DESCRICAO:descricao,          
            CARGA:carga ?? "1",
            CAT_WEB:String(ctWeb ?? "0"),
          },config)
        .then(function(response){
            setMensagem('');
            setSucesso('S');
            console.log(response)
        }).catch((erro) =>{
            setMensagem(erro);
            setSucesso('N');
        });
     } }


     return <div className="conteiner-fluid titulo ">
         <Navbar/>
         <div className="offset-lg-1 col-lg-10">
               <h2>Cadastro de Grupo</h2>      
               <hr />
                <div className="conteiner-fluid">
                <form className="row tela" onsubmit="return false;">

                  <div className="col-2 text-center">
                <div className="mt-2">
                  <img
                    src={imagemProduto}
                    alt="Imagem do Produto"
                    className="img-thumbnail"
                    style={{
                      maxWidth: "100px",
                      height: "100px",
                      cursor: "pointer",
                    }}
                    onClick={() => setIsModalOpenImage(true)}
                  />
                </div>
              </div>
          

            {isModalOpenImage && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                onClick={() => setIsModalOpenImage(false)}
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body p-0">
                      <img
                        src={imagemProduto}
                        alt="Imagem Expandida"
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}


                   
                   <div className="col-5">
                       <label htmlFor="inputAddress" className="form-label">DESCRICAO</label>
                       <input type="text"  value={descricao}  onChange={(e)=> setDescricao(e.target.value)} className="form-control" id="inputDescricao" tabIndex="1" required autoComplete="off" maxLength='20'/>
                   </div>
                  
                   <div className="col-md-1">
                       <label htmlFor="inputState" className="form-label">MOBILE</label>
                       <select id="inputUnidade" value={carga} onChange={(e)=> setCarga(e.target.value)} className="form-select" tabIndex="3" >
                           <option selected value={"1"}>SIM</option>
                           <option value={"0"}>NÃO</option>
                           
                       </select>
                   </div>
                  <div className="col-md-2">
  <label htmlFor="inputCtWeb" className="form-label">CATALOGO WEB</label>
  <div className="input-group mb-3">
    <input 
      type="text"  
      value={ctWeb}  
      onChange={(e)=> setCtWeb(e.target.value)} 
      className="form-control" 
      id="inputCtWeb" 
      autoComplete="off"
      disabled
    />
    <button 
      type="button" 
      className="btn btn-secondary" 
      data-bs-toggle="modal" 
      data-bs-target="#modalCtWeb"
    >
      pesquisar
    </button>
  </div>

  {/* MODAL DE CATALOGO WEB */}
  <div className="modal fade mt-5" id="modalCtWeb" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="modalCtWebLabel" aria-hidden="true">
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="modalCtWebLabel">Pesquisa Catálogo Web</h1>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div className="modal-body">
          {/* CAMPO DE PESQUISA */}
          <div className="input-group mb-3">
            <input 
              type="text" 
              className="form-control" 
              placeholder="Digite sua pesquisa" 
              onChange={(e) => setBuscaCtWeb(e.target.value)} 
            />
            <button 
              
              className="btn btn-primary" 
              type="button"
            >
              <i className="fas fa-search"></i> Pesquisar
            </button>
          </div>

          {/* TABELA DE RESULTADOS */}
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descrição</th>
                <th scope="col">Carga</th>
                <th scope="col">Ação</th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {gruposCtWeb ? gruposCtWeb.map((grupo) => (
                <tr key={grupo.id}>
                  <td>{grupo.id}</td>
                  <td>{grupo.nome}</td>
                  <td>{grupo.mobile === true ? 'Sim' : 'Não'}</td>
                  <td>
                    <a 
                      href="#" 
                      onClick={(e) => {
                        e.preventDefault();
                        setCtWeb(grupo.id);
                      }} 
                      data-bs-dismiss="modal"
                    >
                      <i className="bi bi-check2 icone-acao"></i>
                    </a>
                  </td>
                </tr>
              )): BuscaVazaia}
            </tbody>
          </table>
        </div>
 
      </div>
    </div>
  </div>
</div>

                   <div className="col-md-2">
                        <label htmlFor="inputState" className="form-label">AUTO-ATENDIMENTO</label>
                        <input type="text"  value={autoAtendimento}  onChange={(e)=> setAutoAtendimento(e.target.value)} className="form-control" id="inputCtWeb" tabIndex="4" autoComplete="off"/>
                    </div>
                   
                   <div className="col-12">
                   <hr />
                       <Link to={`/app/grupo/`} type="submit" className="btn btn-outline-primary butao"  tabIndex="14">Desistir</Link>
                       <button type="submit" onClick={salvaGrupo} className="btn btn-primary butao" tabIndex="13">Salvar</button>
                   </div>
       
                   {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                   {sucesso === 'S' ? <Navigate to={`/app/grupo/`}/> : null}
       
                   </form> 
            </div>

            {
           erroValidacao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErrovalidacao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }
        </div>  
        <FooterBar/>
   </div>

}



export default NovoGrupo;